/* ============================================================
   FRETE CEREJA REAL — motor do widget de CEP e da barra de
   frete grátis. As tarifas/pisos ESPELHAM o checkout
   (Configurações > Envio e entrega > Perfil geral).
   Se mudar lá, mude aqui em ZONAS também.
   ============================================================ */
(function () {
  'use strict';

  var ZONAS = {
    es:    { nome: 'Espírito Santo',              flat: 12.90, gratis: 150, prazo: '2 a 6 dias úteis' },
    sesul: { nome: 'Sudeste, Sul e Brasília',     flat: 19.90, gratis: 200, prazo: '4 a 9 dias úteis' },
    resto: { nome: 'Norte, Nordeste e C.-Oeste',  flat: 29.90, gratis: 300, prazo: '6 a 13 dias úteis' }
  };

  /* Zona pela faixa do CEP (3 primeiros dígitos) — offline, sem API. */
  function zonaDoCep(cep) {
    var d = String(cep || '').replace(/\D/g, '');
    if (d.length !== 8) return null;
    var p = parseInt(d.slice(0, 3), 10);
    if (p >= 290 && p <= 299) return 'es';                          /* ES */
    if (p <= 399) return 'sesul';                                   /* SP, RJ, MG */
    if ((p >= 700 && p <= 727) || (p >= 730 && p <= 736)) return 'sesul'; /* DF */
    if (p >= 800) return 'sesul';                                   /* PR, SC, RS */
    return 'resto';                                                 /* N, NE, CO */
  }

  function brl(v) {
    return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  function getCep() { try { return localStorage.getItem('cr_cep') || ''; } catch (e) { return ''; } }
  function setCep(c) {
    try { localStorage.setItem('cr_cep', c); } catch (e) {}
    document.dispatchEvent(new CustomEvent('cr:cep'));
  }
  function mascara(el) {
    el.addEventListener('input', function () {
      var d = el.value.replace(/\D/g, '').slice(0, 8);
      el.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
    });
  }

  /* ---------- Widget da página de produto: calcule frete e prazo ---------- */
  if (!customElements.get('cereja-frete-calc')) {
    customElements.define('cereja-frete-calc', class extends HTMLElement {
      connectedCallback() {
        var cep = getCep();
        this.innerHTML =
          '<div class="crf-box">' +
          '  <div class="crf-titulo">🚚 Calcule frete e prazo</div>' +
          '  <div class="crf-linha">' +
          '    <input class="crf-cep" type="text" inputmode="numeric" autocomplete="postal-code" placeholder="Seu CEP" maxlength="9" value="' + cep + '">' +
          '    <button class="crf-ok" type="button">OK</button>' +
          '  </div>' +
          '  <div class="crf-resultado" role="status"></div>' +
          '</div>';
        var input = this.querySelector('.crf-cep');
        var btn = this.querySelector('.crf-ok');
        var self = this;
        mascara(input);
        btn.addEventListener('click', function () { self.calcular(input.value, true); });
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.calcular(input.value, true); } });
        if (cep) this.calcular(cep, false);
      }
      calcular(cep, salvar) {
        var out = this.querySelector('.crf-resultado');
        var z = zonaDoCep(cep);
        if (!z) { out.innerHTML = '<span class="crf-erro">Digite um CEP válido (8 números).</span>'; return; }
        if (salvar) setCep(cep.replace(/\D/g, '').replace(/(\d{5})(\d{3})/, '$1-$2'));
        var Z = ZONAS[z];
        out.innerHTML =
          '<div class="crf-res-frete">Frete <b>' + brl(Z.flat) + '</b> — <b class="crf-verde">GRÁTIS a partir de ' + brl(Z.gratis) + '</b></div>' +
          '<div class="crf-res-prazo">Chega em <b>' + Z.prazo + '</b> (' + Z.nome + ')</div>';
      }
    });
  }

  /* ---------- Barra "faltam R$ X para o frete grátis" (carrinho) ---------- */
  if (!customElements.get('cereja-frete-barra')) {
    customElements.define('cereja-frete-barra', class extends HTMLElement {
      connectedCallback() {
        this.render();
        var self = this;
        this._on = function () { self.render(); };
        document.addEventListener('cr:cep', this._on);
      }
      disconnectedCallback() { document.removeEventListener('cr:cep', this._on); }
      render() {
        var total = parseInt(this.getAttribute('data-total') || '0', 10) / 100;
        if (!(total > 0)) { this.innerHTML = ''; return; }
        var cep = getCep();
        var z = cep ? zonaDoCep(cep) : null;
        if (!z) {
          this.innerHTML =
            '<div class="crb"><div class="crb-pergunta">Quanto falta p/ <b>FRETE GRÁTIS</b>? Digite seu CEP:' +
            ' <input class="crb-cep" type="text" inputmode="numeric" placeholder="00000-000" maxlength="9">' +
            ' <button class="crb-ok" type="button">OK</button></div></div>';
          var input = this.querySelector('.crb-cep');
          var self = this;
          mascara(input);
          this.querySelector('.crb-ok').addEventListener('click', function () {
            if (zonaDoCep(input.value)) setCep(input.value); else input.classList.add('crb-cep-erro');
          });
          input.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') { e.preventDefault(); if (zonaDoCep(input.value)) setCep(input.value); }
          });
          return;
        }
        var Z = ZONAS[z];
        var falta = Z.gratis - total;
        /* barra = elemento ÚNICO preenchido por gradiente (imune a conflitos de CSS do tema) */
        /* &#8203; (espaço invisível) evita regras tipo div:empty{display:none}; display block !important vence o resto */
        function trilha(p, cor) {
          return '<div class="crb-trilha" style="display:block!important;height:9px!important;border-radius:5px;margin-top:8px;' +
            'font-size:0;line-height:0;overflow:hidden;' +
            'background:linear-gradient(90deg,' + cor + ' ' + p + '%,rgba(0,0,0,.13) ' + p + '%)">&#8203;</div>';
        }
        if (falta <= 0) {
          this.innerHTML =
            '<div class="crb crb-ganhou">🎉 <b>Você ganhou FRETE GRÁTIS!</b>' + trilha(100, '#1a7f1a') + '</div>';
        } else {
          var pct = Math.max(3, Math.min(100, Math.round(100 * total / Z.gratis)));
          this.innerHTML =
            '<div class="crb">Faltam <b>' + brl(falta) + '</b> para <b class="crf-verde">FRETE GRÁTIS</b> <span class="crb-regiao">(' + Z.nome + ')</span>' +
            trilha(pct, '#1a7f1a') + '</div>';
        }
      }
    });
  }
})();
